import type React from 'react';

import { ClientRender } from '@change-corgi/core-react/ssr/render';

import { TrackExperimentExposure } from '#src/app/shared/components/tracking';

import { ToastCard } from '../components/ToastCard';
import { useUkSurgingPetitionToast } from '../hooks/useUkSurgingPetitionToast';

const UkSurgingPetitionToastInner: React.FC<EmptyProps> = () => {
	const { experiment, shouldRenderToast, petition, onDismiss, onCtaClick } = useUkSurgingPetitionToast();

	return (
		<>
			{/* Fires $exposure once for both arms (control included); no-ops on fallback/override. */}
			{experiment && <TrackExperimentExposure experiment={experiment} />}
			{shouldRenderToast && petition && (
				<ToastCard
					displayTitle={petition.displayTitle}
					photo={petition.photo}
					signatureCount={petition.signatureCount}
					onDismiss={onDismiss}
					onCtaClick={onCtaClick}
				/>
			)}
		</>
	);
};

/**
 * App-chrome-level entry for the UK surging-petition toast. The session/experiment/storage-dependent
 * subtree renders client-only (guest pages are server-cached), mirroring `app/banner`.
 */
export const UkSurgingPetitionToast: React.FC<EmptyProps> = () => (
	<ClientRender>
		<UkSurgingPetitionToastInner />
	</ClientRender>
);
